import styled from 'styled-components';
import { TrimTitleSectionStyled } from '../TrimTitleSectionStyled';
import { rem } from 'polished';

export const TrimTitleSectionStyledAP = styled(TrimTitleSectionStyled)`
    .title {
        font-size: ${rem(25)};
        font-family: ${({ theme }) => theme.fonts.fontV2};
    }
`;
